/**
 * Centrale plek voor de lopende actie.
 * Pas hier de datum, prijs en voorwaarden aan — de website werkt overal
 * automatisch bij (homepage-banner en de pagina /actievoorwaarden).
 */
export const PROMOTION = {
  /** Titel van de actie zoals getoond op de actievoorwaardenpagina. */
  title: "Actie: AEG 3-fase groepenkast",
  /**
   * Aantal dagen dat de actie vanaf vandaag geldig is.
   * De einddatum loopt hierdoor automatisch mee: hij ligt altijd
   * dit aantal dagen in de toekomst.
   */
  validDays: 14,
  /** Volledige actievoorwaarden, één regel per punt. */
  terms: [
    "De actieprijs van €\u00a0799,- inclusief montage is een vanafprijs en geldt voor een standaard 3-fase AEG groepenkast met 4 groepen, 1 kookgroep en 3 aardlekschakelaars, inclusief plaatsing bij een reguliere woning met een 1-fase of 3-fase aansluiting.",
    "De uiteindelijke prijs kan afwijken indien de elektrische installatie extra werkzaamheden vereist, zoals het vervangen van bestaande kabels, het aanpassen van de hoofdzekering, het verplaatsen van de meterkast of het toevoegen van extra groepen.",
    "De actie is uitsluitend geldig voor particuliere woningeigenaren in Nederland en bij bestelling via een offerte-aanvraag via de website.",
    "De actie is niet combineerbaar met andere lopende acties, kortingscodes of aanbiedingen, tenzij uitdrukkelijk anders vermeld.",
    "De getoonde prijs is inclusief btw en inclusief montage op een reguliere werkdag (maandag t/m vrijdag, tussen 08:00 en 17:00). Een montageafspraak wordt binnen 14 werkdagen na akkoord op de offerte ingepland, afhankelijk van beschikbaarheid.",
    "Voor eventuele meerwerkzaamheden wordt vooraf een passende offerte verstrekt. Deze werkzaamheden vallen niet onder de actieprijs.",
    "Na acceptatie van de offerte kan de bestelling kosteloos worden geannuleerd tot 48 uur voor de geplande montagedatum. Bij annulering binnen 48 uur worden de gemaakte kosten in rekening gebracht.",
    "Wij behouden ons het recht voor om de actievoordelen, looptijd of voorwaarden tussentijds te wijzigen of de actie te beëindigen. Reeds geaccepteerde offertes blijven van kracht.",
    "Voor vragen over de actievoorwaarden kunt u contact met ons opnemen via het contactformulier of per e-mail.",
  ],
} as const;

/**
 * Einddatum van de actie: vandaag (Nederlandse tijd) plus het aantal
 * geldige dagen. Loopt dus automatisch mee, zonder code aan te passen.
 */
export function promotionEndDateISO(): string {
  // Huidige datum in Nederlandse tijdzone, zodat server en browser gelijk zijn.
  const today = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Amsterdam",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
  const end = new Date(`${today}T00:00:00Z`);
  end.setUTCDate(end.getUTCDate() + PROMOTION.validDays);
  return end.toISOString().slice(0, 10);
}

/** 31-12-2026 */
export function promotionEndShort(): string {
  const [y, m, d] = promotionEndDateISO().split("-");
  return `${d}-${m}-${y}`;
}

/** 31 december 2026 */
export function promotionEndLong(): string {
  return new Date(`${promotionEndDateISO()}T00:00:00Z`).toLocaleDateString(
    "nl-NL",
    { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" },
  );
}
